import Resource from '@/api/core/resource' 

class Users extends Resource {
  constructor () {
    super('Users')
  }
 
  createAdminAccount(credentials) {
    return this.request.post(this.uri.concat('/createadmin'), credentials)
  }
  getUsers(userListRequest){
    return this.request.post(this.uri.concat('/List'),userListRequest)
  }
  getRoles(){
    return this.request.get(this.uri.concat('/ListRoles'))
  }
  disableUser(userId){
    return this.request.post(this.uri.concat('/DisableUser/'+ userId))
  }
  editUser(userEdited){
    return this.request.post(this.uri.concat('/EditUser'), userEdited)
  }
  enableUser(userId){
    return this.request.post(this.uri.concat('/EnableUser/' + userId))
  }  
  confirmNewUser(confirmViewModel){
    return this.request.post(this.uri.concat('/confirmNewUser'),confirmViewModel)
  }
}

export default new Users()
